import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FONTAWESOME_VARIANT } from '../../config';

const DashboardWidget = ({ id, icon, label, url }) => {
  
  return (
    <div className="col d-flex align-items-center card bg-light" id={id}>
      <div className="card-body text-center">
        <i className={FONTAWESOME_VARIANT + " fa fa-7x text-info " + icon}></i>
        <div className="mt-4">
          <Link to={url} className="btn btn-primary">
            {label}
          </Link>
        </div>
      </div>
    </div>
  );
};

DashboardWidget.propTypes = {
  id: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default DashboardWidget;